import * as Location from "expo-location";

const locationHelpers = {
  async getLocation() {
    let { status } = await Location.requestForegroundPermissionsAsync();
    console.warn("location permission", status);
    if (status !== "granted") {
      // alert("Permission to access location was denied");
      return null;
    }
    try {
      let location = await Promise.race([
        Location.getCurrentPositionAsync({
          accuracy: Location.Accuracy.Lowest,
          maximumAge: 300000,
        }),
        new Promise((resolve) => setTimeout(() => resolve(null), 2000)),
      ]);
      console.log("location coords", location?.coords);
      return location;
    } catch (e) {
      console.log("location error", e);
    }
  },
};

export default locationHelpers;
